module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "flex"
    }
  }, [(_vm.brandName != '') ? _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.brandName))])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "search",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("选择")])], 1), _vm._v(" "), (_vm.brandName != '') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "delete2",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": _vm.delBrand
    }
  }, [_vm._v("删除")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择品牌",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-bottom": "20px"
    },
    model: {
      value: (_vm.brandNameTemp),
      callback: function($$v) {
        _vm.brandNameTemp = $$v
      },
      expression: "brandNameTemp"
    }
  }), _vm._v(" "), _c('el-table', {
    ref: "brandTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.brandList,
      "highlight-current-row": "",
      "border": "",
      "tooltip-effect": "dark",
      "height": "400"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "品牌ID",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "label",
      "label": "品牌名称",
      "align": "center",
      "min-width": "300"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.dialogConfirm
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9c996c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/addBook/BrandChose.vue
// module id = 730
// module chunks = 1